interface OwnOmit {
    // eslint-disable-next-line
    <T extends object, K extends [...(keyof T)[]]>(obj: T, ...keys: K): {
        [K2 in Exclude<keyof T, K[number]>]: T[K2];
    };
}

export const partition = <T extends Record<string, unknown>>(
    arr: T[],
    predicate: (arg: T) => boolean,
) => {
    return arr.reduce<[T[], T[]]>(
        ([accept, decline], curr) => {
            if (predicate(curr)) {
                accept.push(curr);
            } else {
                decline.push(curr);
            }
            return [accept, decline];
        },
        [[], []],
    );
};

export function stripPhone(val: string) {
    // eslint-disable-next-line no-useless-escape
    return val.replace(/[^\d\+]/g, '');
}

export const omit: OwnOmit = (obj, ...keys) => {
    const ret = {} as {
        [K in keyof typeof obj]: typeof obj[K];
    };
    let key: keyof typeof obj;
    // eslint-disable-next-line
    for (key in obj) {
        if (!keys.includes(key)) {
            ret[key] = obj[key];
        }
    }
    return ret;
};
